import activityHistory from "./activityHistory.json"
import activityMessages from "./activityMessages.json"
import activityStats from "./activityStats.json"
import adminDashboard from "./adminDashboard.json"
import agentMode from "./agentMode.json"
import agents from "./agents.json"
import analysisPanel from "./analysisPanel.json"
import answer from "./answer.json"
import answerLoadingMessages from "./answerLoadingMessages.json"
import arrowButton from "./arrowButton.json"
import artifacts from "./artifacts.json"
import authError from "./authError.json"
import canvas from "./canvas.json"
import chatHome from "./chatHome.json"
import chatSession from "./chatSession.json"
import clearChatButton from "./clearChatButton.json"
import common from "./common.json"
import compliancePopup from "./compliancePopup.json"
import customGptModelSettings from "./customGptModelSettings.json"
import dash from "./dash.json"
import deepExplorer from "./deepExplorer.json"
import dynamicTitles from "./dynamic_titles.json"
import factCheck from "./factCheck.json"
import fairUse from "./fairUse.json"
import feedback from "./feedback.json"
import filePicker from "./filePicker.json"
import greeting from "./greeting.json"
import image from "./image.json"
import indexing from "./indexing.json"
import libraries from "./libraries.json"
import localAiLead from "./localAiLead.json"
import m365Tool from "./m365Tool.json"
import mermaid from "./mermaid.json"
import modelDisclaimers from "./modelDisclaimers.json"
import notifications from "./notifications.json"
import pages from "./pages.json"
import personalization from "./personalization.json"
import personalSources from "./personalSources.json"
import plugins from "./plugins.json"
import projects from "./projects.json"
import projectSettings from "./projectSettings.json"
import promptPresets from "./promptPresets.json"
import prompts from "./prompts.json"
import promptSettings from "./promptSettings.json"
import questionInput from "./questionInput.json"
import reasoningMode from "./reasoningMode.json"
import reasoningModel from "./reasoningModel.json"
import segmentAnalysis from "./segmentAnalysis.json"
import settingsButton from "./settingsButton.json"
import settingsMenu from "./settingsMenu.json"
import sharing from "./sharing.json"
import slideSense from "./slideSense.json"
import sources from "./sources.json"
import spreadsheet from "./spreadsheet.json"
import studioAi from "./studioAi.json"
import tender from "./tender.json"
import textEnhancement from "./textEnhancement.json"
import textInputDropdown from "./textInputDropdown.json"
import textSelection from "./textSelection.json"
import training from "./training.json"
import trainingGating from "./trainingGating.json"
import translationDictionary from "./translationDictionary.json"
import translatorTool from "./translatorTool.json"
import useCases from "./useCases.json"
import userAgreementButton from "./userAgreementButton.json"
import userChatMessage from "./userChatMessage.json"
import userInstructionButton from "./userInstructionButton.json"
import voiceMode from "./voiceMode.json"
import voiceTranscript from "./voiceTranscript.json"
import workflowLanding from "./workflowLanding.json"

export const translation = {
  ...translatorTool,
  ...plugins,
  ...artifacts,
  ...authError,
  ...activityHistory,
  ...activityMessages,
  ...activityStats,
  ...adminDashboard,
  ...agentMode,
  ...agents,
  ...analysisPanel,
  ...answer,
  ...answerLoadingMessages,
  ...arrowButton,
  ...canvas,
  ...chatHome,
  ...chatSession,
  ...clearChatButton,
  ...common,
  ...compliancePopup,
  ...customGptModelSettings,
  ...dash,
  ...dynamicTitles,
  ...factCheck,
  ...fairUse,
  ...feedback,
  ...filePicker,
  ...greeting,
  ...image,
  ...indexing,
  ...libraries,
  ...localAiLead,
  ...m365Tool,
  ...mermaid,
  ...modelDisclaimers,
  ...notifications,
  ...pages,
  ...personalization,
  ...personalSources,
  ...projects,
  ...projectSettings,
  ...promptPresets,
  ...sharing,
  ...prompts,
  ...promptSettings,
  ...questionInput,
  ...reasoningMode,
  ...reasoningModel,
  ...settingsButton,
  ...settingsMenu,
  ...sources,
  ...spreadsheet,
  ...textEnhancement,
  ...textInputDropdown,
  ...textSelection,
  ...training,
  ...trainingGating,
  ...translationDictionary,
  ...userAgreementButton,
  ...userChatMessage,
  ...userInstructionButton,
  ...studioAi,
  ...segmentAnalysis,
  ...useCases,
  ...slideSense,
  ...workflowLanding,
  ...voiceMode,
  ...voiceTranscript,
  ...tender,
  ...deepExplorer,
}
